import React, { useState } from "react";
import { Link } from "react-router-dom";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    subject: "",
    email: "",
    phone: "",
    location : "San Francisco",
    message: "",
    smsConsent: false,
  });

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(""); // message text
  const [statusType, setStatusType] = useState(""); // success | error | info

  // const GOOGLE_SCRIPT_URL =
  //   "https://script.google.com/macros/s/AKfycbyMVGjUDnLa_B6RLQ62fwqeRQ85f_8vukAd4R2nRLM8SdS93-_H9ogY6JSSG9dJsGhMpQ/exec";

    const GOOGLE_SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycbwbe8GpHA9ngG7cFyKoFfWic3yrKGB9xNrbiD6vohLyDSVQoM865gKp2kAmqCUXPZCpfA/exec";

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // basic validation
    if (!formData.name || !formData.email || !formData.phone || !formData.message || !formData.subject) {
      setStatus("⚠️ Please complete all required fields before submitting.");
      setStatusType("error");
      return;
    }

    setLoading(true);
    setStatus("⏳ Sending your message, please wait...");
    setStatusType("info");

    try {
      const response = await fetch(GOOGLE_SCRIPT_URL, {
        method: "POST",
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.status === "success") {
        setStatus("✅ Thank you for contacting us! We’ve received your message and will get back to you within 24–48 hours.");
        setStatusType("success");
        setFormData({
          name: "",
          subject: "",
          email: "",
          phone: "",
          location : "San Francisco",
          message: "",
          smsConsent: false,
        });
      } else {
        setStatus("❌ Something went wrong while submitting your form. Please try again in a few minutes.");
        setStatusType("error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setStatus("❌ Unable to connect to the server. Please check your internet connection and try again.");
      setStatusType("error");
    }

    setLoading(false);
  };

  return (
    <div className="contact-container" style={{ maxWidth: "600px", margin: "0 auto" }}>
      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>First and Last Name</label>
          <input
            type="text"
            name="name"
            placeholder="Please enter your full name here"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Subject</label>
          <select
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
          >
            <option value="">Select message subject</option>
            <option value="ScriptPak™">ScriptPak™</option>
            <option value="ScriptInject™">ScriptInject™</option>
            <option value="ScriptWeb™">ScriptWeb™</option>
            <option value="Other">Other</option>
          </select>
        </div>

        <div className="form-group">
          <label>Email Address</label>
          <input
            type="email"
            name="email"
            placeholder="Type your email address here"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Phone Number</label>
          <input
            type="tel"
            name="phone"
            placeholder="Type your phone number here"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label>Message</label>
          <textarea
            name="message"
            placeholder="Type your message here"
            value={formData.message}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group sms-consent-group" style={{ flexDirection: "row", alignItems: "flex-start", gap: "10px" }}>
          <input
            type="checkbox"
            id="smsConsent"
            name="smsConsent"
            checked={formData.smsConsent}
            onChange={handleChange}
            style={{ width: "auto", marginTop: "4px" }}
          />
          <label htmlFor="smsConsent" style={{ fontSize: "14px", fontWeight: 400 }}>
            I agree to receive SMS messages from ScriptSite regarding my
            inquiry, customer service, billing, and account updates. Message
            frequency may vary. Message and data rates may apply. Reply STOP
            to opt out or HELP for assistance. Consent is not required to
            purchase goods or services. See our{" "}
            <Link to="/privacy-terms-of-service">Privacy Policy and SMS Terms &amp; Conditions</Link>.
          </label>
        </div>

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? "Submitting..." : "Submit"}
        </button>

        {status && (
          <p
            style={{
              marginTop: "12px",
              fontWeight: "500",
              color:
                statusType === "success"
                  ? "green"
                  : statusType === "error"
                  ? "red"
                  : "#555",
            }}
          >
            {status}
          </p>
        )}
      </form>
    </div>
  );
};

export default ContactForm;
